import { createDivIn, createSpanIn } from '../ui_utils/DomUtils.ts';
export class UIReconnectingBackgroundView {
    static show(text) {
        if (this.connectionLostBackground != undefined) return;
        const overlay = createDivIn(document.body, 'game-reconnecting-overlay');
        createDivIn(overlay, 'loading-spinner');
        createSpanIn(overlay, 'game-reconnecting-text', text);
        this.connectionLostBackground = overlay;
    }
    static remove() {
        if (this.connectionLostBackground != undefined) this.connectionLostBackground.remove();
        this.connectionLostBackground = undefined;
    }
}
